import {parseCookies} from 'nookies';
import {useCallback, useEffect, useState} from 'react';
import {
  useDeleteFollowCompany,
  useUpdateFollowCompany,
} from '../repositories/companiesRepository';

type Props = {
  companyId: number;
  followCount: number;
  followed: boolean;
  onFollowSuccess?: () => void;
};

export function useHandleFollowCompany({
  companyId,
  followCount,
  followed,
  onFollowSuccess,
}: Props) {
  const cookies = parseCookies();
  const [followCountUpdated, setFollowCountUpdated] =
    useState<number>(followCount);
  const [isFollowed, setIsFollowed] = useState<boolean>(followed);

  const updateFollowCompany = useUpdateFollowCompany({
    onSuccessFunc({followCompanyCount}) {
      setIsFollowed(true);
      setFollowCountUpdated(followCompanyCount);
      onFollowSuccess?.();
    },
  });
  const deleteFollowCompany = useDeleteFollowCompany({
    onSuccessFunc({followCompanyCount}) {
      setIsFollowed(false);
      setFollowCountUpdated(followCompanyCount);
    },
  });

  useEffect(() => {
    setFollowCountUpdated(followCount);
    setIsFollowed(followed);
  }, [companyId, followed, followCount]);

  const unFollowCompanyUsecase = useCallback(
    async function unFollowCompanyUsecase() {
      deleteFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const updateFollowCompanyUsecase = useCallback(
    async function updateFollowCompanyUsecase() {
      updateFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const handleFollowCompany = useCallback(async () => {
    if (isFollowed) {
      await unFollowCompanyUsecase();
      return;
    }

    await updateFollowCompanyUsecase();
  }, [unFollowCompanyUsecase, isFollowed, updateFollowCompanyUsecase]);

  return {
    handleFollowCompany,
    followCountUpdated,
    isFollowed,
    updateFollowCompanyUsecase,
  };
}
